import { useSelector } from 'react-redux';

/**
 * Catalogue des permissions activables pour un compte assistant — reflet exact
 * du catalogue backend (src/common/assistant-permissions.ts côté API). Garder
 * les deux synchronisés si une permission est ajoutée/retirée côté serveur.
 */
export const ASSISTANT_PERMISSIONS = [
  'entreprises.changerStatut',
  'entreprises.validerAbonnement',
  'entreprises.prolongerEssai',
  'entreprises.envoyerEmail'
];

/**
 * Lit le profil chargé par getProfile() (dispatché au montage de Userbox) et
 * expose ce qu'un compte connecté a le droit de voir/faire :
 *  - isSuperAdmin  : accès complet, toujours vrai pour can(...)
 *  - isAssistant   : compte SUPER_ADMIN_ASSISTANT, accès borné à Entreprises
 *  - can(perm)     : true pour un super admin, sinon dépend de profile.permissions
 *
 * Un compte ni super admin ni assistant (ne devrait pas arriver sur cette
 * plateforme) ne passe aucun can(...).
 */
export function useAssistantAccess() {
  const profile = useSelector((x) => x.user?.profile);
  const accountType = profile?.account_type;
  const isSuperAdmin = accountType === 'SUPER_ADMIN';
  const isAssistant = accountType === 'SUPER_ADMIN_ASSISTANT';
  const permissions = isAssistant ? profile?.permissions || [] : [];

  const can = (permission) => isSuperAdmin || permissions.includes(permission);

  return { accountType, isSuperAdmin, isAssistant, permissions, can };
}
